import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams, DocumentSignedURL, DocumentPagesPayload } from '../types/main';
import { ItemId, Document } from '../types/items';
import { MediaFormDocument } from '../types/formItems';
import { transformList } from './transformer';

class DocumentService {
  private route = apis.documents;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api.get<List<Document>>(this.route.default, params).then(transformList);

  get = (id: ItemId) => this.api.get<Document>(`${this.route.default}/${id}`);

  template = () => this.api.get<Document>(`${this.route.default}/new`);

  save = (document: Document | MediaFormDocument) => this.api.put(`${this.route.default}/${document.id}`, document);

  sync = (id: ItemId) => this.api.put<Document>(`${this.route.default}/${id}/sync`, {});

  syncTypes = () => this.api.post<number[]>(`${this.route.default}/sync-types`, {});

  create = (document: Document) => this.api.post<Document>(this.route.default, document);

  delete = (id: ItemId) => this.api.delete(`${this.route.default}/${id}`);

  uploadUrl = (id: ItemId) => this.api.get<DocumentSignedURL>(`${this.route.default}/${id}/upload-url`);

  downloadUrl = (id: ItemId) => this.api.get<DocumentSignedURL>(`${this.route.default}/${id}/download-url`);

  downloadByUrl = (url: string) => this.api.get<DocumentSignedURL>(url);

  getPageInfo = (id: ItemId) => this.api.get<DocumentPagesPayload>(`${this.route.default}/${id}/pages`);
}

export default new DocumentService(apiService);
